export default {
  StopDuration__CHANGE_PLANES_ARIA_LABEL: "Change of planes at",
  StopDuration__STOP_DURATION_ARIA_LABEL: "Layover duration",
};
